var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1946 2.40019V1.32573C16.1946 0.869248 15.8039 0.499219 15.3474 0.499219H1.21405C0.757569 0.499219 0.408203 0.869248 0.408203 1.32573V9.67349C0.408203 10.13 0.757569 10.5 1.21405 10.5H15.3474C15.8039 10.5 16.1946 10.13 16.1946 9.67349V4.71442",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1946 7.80374C16.1946 7.96929 16.0603 8.10352 15.8948 8.10352H0.707979C0.542428 8.10352 0.408203 7.96929 0.408203 7.80374V5.84111C0.408203 5.67556 0.542428 5.54133 0.707979 5.54133H15.8948C16.0603 5.54133 16.1946 5.67556 16.1946 5.84111V7.80374Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56543 2.31836H3.71436",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4926 4.45117L12.5771 3.53573L13.4926 2.62029",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6699 3.50601C12.6699 3.50601 17.3474 3.51155 17.3658 3.5123C18.0694 3.5404 18.5914 4.10639 18.5914 4.8181V4.9834C18.5914 5.71371 18.0613 6.28516 17.3309 6.28516H17.1863",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.2409e76a187515bfcfb96fb492d9868d.svg";
export { ForwardRef as ReactComponent };